import styled from "styled-components";
import Contributors from "./Contributors";

export const StyledHeader = styled.div`
  ${({ theme }) => `
    max-width: 100%;
    background-color: ${theme.colors.white};
    margin-bottom: ${theme.space.sm};
    color: ${theme.colors.gray800};
    font-size: ${theme.font.size.sm};
    line-height: ${theme.line.height.base};

    sub {
      vertical-align: sub;
      font-size: smaller;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.font.size.md};
    }

    @media (min-width: ${theme.breakpoints.md}) {
      margin-bottom: ${theme.space.sm};
      line-height: ${theme.line.height.icon};
    }
  `}
`;

export const StyledTitleHolder = styled.div`
  max-width: 90rem;
  margin: 0 auto;
  position: relative;
  width: 100%;
`;

export const StyledLogo = styled.img`
  max-width: 10rem;
  max-height 2rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: 12.5rem;
    max-height 2.5rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 15rem;
    max-height: 3rem;
  }
`;

export const StyledContributors = styled(Contributors)`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: ${({ theme }) => theme.space.sm};
  }
`;
